(function () {
const $33f882eda0dd4287$var$systemUrls = {
    async: '/WebPortal/async.aspx',
    asyncReadOnly: '/WebPortal/AsyncReadOnly.aspx'
};
if (!window.opacc) window.opacc = {};
if (!window.opacc.systemUrls) window.opacc.systemUrls = {};
window.opacc.systemUrls = $33f882eda0dd4287$var$systemUrls;

})();
//# sourceMappingURL=projectsettings.js.map
